import { useState, useEffect, useCallback } from "react";
import { themes, getStoredTheme, applyTheme, setStoredTheme, getEffectiveTheme } from "../utils/theme";

export const useThemeManager = (initialTheme = null) => {
  const [theme, setTheme] = useState(() => initialTheme || getStoredTheme());
  const [effectiveTheme, setEffectiveTheme] = useState(() => getEffectiveTheme(theme));

  // Apply theme on initial load
  useEffect(() => {
    const storedTheme = getStoredTheme();
    applyTheme(storedTheme);
    setTheme(storedTheme);
    setEffectiveTheme(getEffectiveTheme(storedTheme));
  }, []);

  useEffect(() => {
    applyTheme(theme);
    setEffectiveTheme(getEffectiveTheme(theme));
  }, [theme]);


  const toggleTheme = useCallback(() => {
    const newTheme = theme === themes.LIGHT ? themes.DARK : themes.LIGHT;
    setTheme(newTheme);
    setStoredTheme(newTheme);
  }, [theme]);

  const setThemeDirectly = useCallback((newTheme) => {
    if (newTheme && Object.values(themes).includes(newTheme)) {
      setTheme(newTheme);
      setStoredTheme(newTheme);
    }
  }, []);

  const syncThemeFromAccount = useCallback((accountTheme) => {
    if (accountTheme && Object.values(themes).includes(accountTheme)) {
      setTheme(accountTheme);
      setStoredTheme(accountTheme);
    }
  }, []);

  return {
    theme,
    effectiveTheme,
    themes,
    toggleTheme,
    setTheme: setThemeDirectly,
    syncThemeFromAccount,
  };
};